import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { TenantAuthService } from './tenant-auth.service';

export const tenantAuthGuard: CanActivateFn = (_route, state) => {
  const tenantAuthService = inject(TenantAuthService);
  const router = inject(Router);

  if (tenantAuthService.isAuthenticated()) {
    return true;
  }
  return router.createUrlTree(['/rms/tenant/login'], { queryParams: { returnUrl: state.url } });
};
